﻿export function getQuestionInfo(templateLayout, questionId) {
    let questionCounter = 1;

    function traverse(pages) {
        for (const page of pages) {
            const children = page.childComponents || [];
            const isQuestion = typeof page.$componentType === 'string' && page.$componentType.endsWith('Question');

            if (isQuestion) {
                if (page.id === questionId) {
                    return {
                        questionNumber: questionCounter,
                        questionTitle: page.title || ''
                    };
                }
                questionCounter++;
            }

            const result = traverse(children);
            if (result != null) return result;
        }

        return null;
    }

    return traverse(templateLayout.pages || []) || null;
}
